import { ITechincalDocument } from "src/Utils/Hooks/Downloads/useGetTechicalDocuments";
import DocumentsDetails from "../Documents/DocumentsDetails";
import markeingMaterial from 'src/images/additional-marketing-material.png';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const MarketingMaterialDocuments = () => {
    const { t } = useTranslation();

    const [data, setData] = useState<ITechincalDocument[]>();

    useEffect(() => {
        var marketing_data:ITechincalDocument = {
            displayName: t('AdditionalMarketingMaterial'),
            previewData: markeingMaterial,
            sasToken: 'https://hexmet.sharepoint.com/:f:/s/AURA-Partners-Public/IgDwmhRVBZAXRJ_oToWGH7kdAdjpdnuWIZo4KcO6UUXATos?xsdata=MDV8MDJ8fGE0Y2Q5Y2ZkYTcyZjQzMzYxOGJkMDhkZTdlYjVlZjMxfDFiMTZhYjNlYjhmNjRmZTM5ZjNlMmRiN2ZlNTQ5ZjZhfDB8MHw2MzkwODc1MTcwMDAzNDE2OTN8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T2pBellUbGxOMlE1TFRZek1qUXRORGRtTnkxaE0yVTBMVEkwTVRFeE5qWTROMkl5TjE4ME56RTRZMlF3TVMxbU1qRm1MVFJqTjJVdFlXWmtNQzA0TnpBelpUYzVZalJqWkdaQWRXNXhMbWRpYkM1emNHRmpaWE12YldWemMyRm5aWE12TVRjM016RTFORGc1TnprM05nPT18YmZlMDAxMmY0ODc1NDA4MzE4YmQwOGRlN2ViNWVmMzF8NjZkOTEwNDhlMDgxNDNhN2JmNmY0NDM0ZTg4MzZmYmE%3D&sdata=YVBRM0xJRjJramJJV1hVc2pzakZ3NlUxdEtyTFhuR1lxRERxZit5cGU2UT0%3D&ovuser=1b16ab3e-b8f6-4fe3-9f3e-2db7fe549f6a%2Cmarta.maltez%40hexagon.com',
        }
        setData([marketing_data])
    },[t])
    return (
        <>
            {data &&
                <>
                    <hr className='ds-text-primary ds-divider mt-4'></hr>
                    <DocumentsDetails data={data} title={t('MarketingMaterial')} id="marketing-material-doc" />
                </>
            }
        </>
    )
}
export default MarketingMaterialDocuments;